var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagGrenada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98242 2.79337C9.55023 1.03799 12.6551 0.0107422 16.0004 0.0107422C19.3456 0.0107422 22.4505 1.03799 25.0183 2.79337L16.0004 3.48899L6.98242 2.79337Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 16.0109L14.9791 14.9897L14.708 15.4754L16.0003 16.0109Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68625 4.69678C-1.56212 10.9452 -1.56212 21.0758 4.68625 27.3243C7.26831 24.7422 9.75163 22.2589 16 16.0105L4.68625 4.69678Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3137 4.69678C33.5621 10.9452 33.5621 21.0758 27.3137 27.3243C24.7317 24.7422 22.2484 22.2589 16 16.0105L27.3137 4.69678Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21.5757C19.0736 21.5757 21.5652 19.0841 21.5652 16.0105C21.5652 12.9369 19.0736 10.4453 16 10.4453C12.9264 10.4453 10.4348 12.9369 10.4348 16.0105C10.4348 19.0841 12.9264 21.5757 16 21.5757Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9995 10.4453L17.247 14.2846H21.2843L18.0182 16.6579L19.2657 20.4974L15.9995 18.1246L12.7333 20.4974L13.981 16.6579L10.7148 14.2846H14.752L15.9995 10.4453Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0057 0.0107422H15.9951C11.5792 0.0121797 7.58169 1.80237 4.6875 4.69624H27.3133C24.4191 1.80237 20.4215 0.0121797 16.0057 0.0107422Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68756 27.3252C7.58294 30.2201 11.5826 32.0106 16.0004 32.0106C20.4182 32.0106 24.4178 30.2201 27.3132 27.3252H4.68756Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9995 1.75L16.2586 2.54713H17.0967L16.4187 3.03981L16.6777 3.83694L15.9995 3.34431L15.3215 3.83694L15.5805 3.03981L14.9023 2.54713H15.7405L15.9995 1.75Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1206 1.75L12.3797 2.54713H13.2178L12.5398 3.03981L12.7988 3.83694L12.1206 3.34431L11.4426 3.83694L11.7016 3.03981L11.0234 2.54713H11.8616L12.1206 1.75Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8794 1.75L20.1385 2.54713H20.9766L20.2985 3.03981L20.5576 3.83694L19.8794 3.34431L19.2014 3.83694L19.4604 3.03981L18.7822 2.54713H19.6204L19.8794 1.75Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9995 28.1846L16.2586 28.9817H17.0967L16.4187 29.4744L16.6777 30.2715L15.9995 29.7788L15.3215 30.2715L15.5805 29.4744L14.9023 28.9817H15.7405L15.9995 28.1846Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1206 28.1846L12.3797 28.9817H13.2178L12.5398 29.4744L12.7988 30.2715L12.1206 29.7788L11.4426 30.2715L11.7016 29.4744L11.0234 28.9817H11.8616L12.1206 28.1846Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8794 28.1846L20.1385 28.9817H20.9766L20.2985 29.4744L20.5576 30.2715L19.8794 29.7788L19.2014 30.2715L19.4604 29.4744L18.7822 28.9817H19.6204L19.8794 28.1846Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87519 15.7466C5.28613 16.396 5.093 17.2554 4.44369 17.6664C3.79444 18.0774 2.93494 17.8843 2.52394 17.235C1.77988 16.0595 2.21131 14.1396 2.21131 14.1396C2.21131 14.1396 4.13106 14.5711 4.87519 15.7466Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07163 17.7741C4.45582 17.7741 4.76726 17.4626 4.76726 17.0784C4.76726 16.6943 4.45582 16.3828 4.07163 16.3828C3.68745 16.3828 3.37601 16.6943 3.37601 17.0784C3.37601 17.4626 3.68745 17.7741 4.07163 17.7741Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagGrenada);
export default __webpack_public_path__ + "static/media/flag_grenada.ca4be94465224d6baa9861e66164c7ec.svg";
export { ForwardRef as ReactComponent };